import React from 'react';
import TasksList from './TasksList';

interface CompanyTasksListProps {
  publicCompanyId: number;
}

export default function CompanyTasksList(props: CompanyTasksListProps) {
  return (
    <TasksList
      mode="company"
      publicCompanyId={props.publicCompanyId}
      hideFilters={false}
      hideSettings={true}
    />
  );
}